export default __webpack_public_path__ + "static/media/ico-back.342a308d.svg";